/**
 * @generated SignedSource<<baf340345654d7b667c0b172d5f34d26>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ArchiveActionItemsBannerQuery$variables = {};
export type ArchiveActionItemsBannerQuery$data = {
  readonly viewer: {
    readonly toArchivedActionItemsCount: number;
  };
};
export type ArchiveActionItemsBannerQuery = {
  response: ArchiveActionItemsBannerQuery$data;
  variables: ArchiveActionItemsBannerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "toArchivedActionItemsCount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ArchiveActionItemsBannerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ArchiveActionItemsBannerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "063ee69dd2e616ed25f3f2692a89291a",
    "id": null,
    "metadata": {},
    "name": "ArchiveActionItemsBannerQuery",
    "operationKind": "query",
    "text": "query ArchiveActionItemsBannerQuery {\n  viewer {\n    toArchivedActionItemsCount\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ba399df39e29133fe8504adce67aff13";

export default node;
